import React from 'react';

export default class LoaderBall extends React.Component {

    render() {
        return (
            <div className="loader-ball">

            </div>
        );
    }
}


LoaderBall.propTypes = {};

LoaderBall.defaultProps = {};


// WEBPACK FOOTER //
// ./src/js/components/LoaderBall.js